import { render } from "./HeaderComponent.vue?vue&type=template&id=0e7c0b3b"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=0e7c0b3b&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__